import { FETCH_MOTIVATIONS } from '@/constants/query-keys'
import { fetchMotivations } from '@/requests/preLogin/landing.api'
import { useQuery } from '@tanstack/react-query'
import { uniqueId } from 'lodash'

export const useGetMotivations = () => {
  return useQuery({
    queryKey: [FETCH_MOTIVATIONS],
    queryFn: fetchMotivations,
    select: (data: string[]): Interest[] => {
      if (!data?.length) return []

      return data.map((text: string) => ({
        id: uniqueId('motivations-'),
        label: text,
        selected: false,
      }))
    },
  })
}
